import { HttpInterceptorFn } from '@angular/common/http';

export const loggingInterceptor: HttpInterceptorFn = (req, next) => {
  const authHeader = req.headers.get('Authorization');

  return next(req);
};
